import { Box, Divider, Skeleton } from '@factorialco/deprecated-design-system'
import { sample } from 'lodash'

import { premiumOfferCardStyle } from 'modules/ats/pages/JobPostingMarketplace/index.vanilla.css'

export const PremiumBundleCardSkeleton = () => {
  return (
    <Box className={premiumOfferCardStyle}>
      <Box padding="s16" gap="s8">
        <Box borderRadius={{ all: 'rel1000' }} overflowX="hidden" width="fit-content">
          <Skeleton width="s40" height="s40" />
        </Box>
        <Skeleton width={sample(['s140', 's240', 's200'])} height="s16" />
      </Box>
      <Divider />
      <Box flexDirection="row" justifyContent="spaceBetween" alignItems="center" padding="s16">
        <Box flexDirection="row" gap="s6">
          <Skeleton width={sample(['s64', 's48'])} height="s16" />
          <Skeleton width={sample(['s64', 's48'])} height="s16" />
        </Box>
        <Skeleton width="s96" height="s32" />
      </Box>
    </Box>
  )
}
